/**
 * [pug template]
 */
<template lang="pug">
  .gallery
    gallery(:imageList="imageList", :selectedImage="selected", v-on:select-image="selectImage")
</template>
/**
 * [javascript application]
 */
<script>
import clientConfig from '../../config/global'

export default {
  name: 'gallery-block',
  props: {
    imageList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: null
    }
  },
  created: function () {
    if (this.imageList.length) {
      this.selected = this.imageList[0]
    }
  },
  components: clientConfig.rendering_units,
  computed: {},
  watch: {
    /**
     * Détecte la modification de la liste d'image
     * @param  {array} newValue La nouvelle liste d'images
     * @param  {array} oldValue L'ancienne liste d'images
     */
    imageList: function (newValue, oldValue) {
      if (newValue.length) {
        this.selected = newValue[0]
      } else {
        this.selected = null
      }
    }
  },
  methods: {
    /**
     * Assigne l'image sélectionnée
     * @param  {string} data L'image sélectionnée
     */
    selectImage: function (data) {
      this.selected = data
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// GalleryBlock.vue?eeea1b98